import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './CaseDetailsTabs.module.scss';
import Tabs from '../../../core/components/Tabs/Tabs';
import ApiProvider from '../../../core/api/ApiProvider';
import { ResponseApiType } from '../../types/ResponseApiType';
import { Loader, ModuleContainer } from '../../../core/components';
import Activities from './components/Activities/Activities';
import Invoices from './components/Invoices/Invoices';
import Documents from './components/Documents/Documents';
import CaseMessages from './components/CaseMessages/CaseMessages';
import CaseActivityTimeline from './components/Timeline/Timeline';

type TabType = {
  isEnable: boolean;
  isTabDefault: boolean;
  isTabVisible: boolean;
  tabName: string;
  tabTranslation: string;
  tabValue: string;
};

const CaseDetailsTabs = () => {
  const tabIndex = '0';

  const { caseNumber, tenantUId } = useParams() as { caseNumber: string; tenantUId: string };

  const [tabs, setTabs] = useState<TabType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchAvailableTabs = async () => {
    try {
      const result = await ApiProvider.post<ResponseApiType>(
        'CaseDetailsTabsModule/GetAvailableTabs',
        { CaseNo: caseNumber, TenantUId: tenantUId }
      );
      if (result.success) {
        setTabs(result.data.tabs);
        setIsLoading(false);
      }
    } catch (err) {}
  };

  const renderModule = (tabName: string) => {
    switch (tabName) {
      case 'history':
        return <Activities />;
      case 'invoices':
        return <Invoices />;
      case 'documents':
        return <Documents />;
      case 'messages':
        return <CaseMessages />;
      case 'timeline':
        return <CaseActivityTimeline />;
      default:
        <>No available module</>;
    }
  };

  useEffect(() => {
    fetchAvailableTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container">
          <ModuleContainer>
            <ModuleContainer.Body
              variant={ModuleContainer.Body.BodyVariant.Secondary}
              classNames={styles.tabWrapper}
            >
              <Tabs initIndex={tabIndex} className={styles.tab} dataCy="caseDetailsTabs">
                <Tabs.Nav className={styles.tabNav} dataCy="caseDetailsTabsNav">
                  {tabs
                    .filter((tab) => tab.isTabVisible)
                    .map((tab, index) => (
                      <Tabs.Tab
                        id={tab.tabName}
                        key={tab.tabValue}
                        index={`${index}`}
                        className={styles.tabNavItem}
                        classNameActive={styles.tabNavItemActive}
                        label={tab.tabTranslation}
                        component={renderModule(tab.tabValue)}
                      />
                    ))}
                </Tabs.Nav>

                <Tabs.Panel className={styles.tabPanel} dataCy="caseDetailsTabsPanel" />
              </Tabs>
            </ModuleContainer.Body>
          </ModuleContainer>
        </div>
      )}
    </>
  );
};

export default CaseDetailsTabs;
